import * as XLSX from 'xlsx';
import Papa from 'papaparse';

export const parseUserFile = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (evt) => {
      try {
        const data = evt.target.result;
        let list = [];

        if (file.name.endsWith('.xlsx')) {
          const wb = XLSX.read(data, { type: 'binary' });
          const sheet = wb.Sheets[wb.SheetNames[0]];
          const json = XLSX.utils.sheet_to_json(sheet, { header: 1 });
          list = json.map(r => ({ name: String(r[0]).trim() })).filter(u => u.name);
        } else if (file.name.endsWith('.csv')) {
          const parsed = Papa.parse(data, { header: false });
          list = parsed.data.map(r => ({ name: String(r[0]).trim() })).filter(u => u.name);
        }

        resolve(list);
      } catch (err) {
        reject(err);
      }
    };

    if (file.name.endsWith('.xlsx')) reader.readAsBinaryString(file);
    else if (file.name.endsWith('.csv')) reader.readAsText(file);
    else reject(new Error('対応していないファイル形式です'));
  });
};
